// extracted by mini-css-extract-plugin
module.exports = {"navMenu":"navMenu--3BG6Q","icon":"icon--2EvCI","navTitle":"navTitle--MyJG7","tag":"tag--TOZqa","greenButton":"greenButton--2YNXp","campMenuItem":"campMenuItem--2t7lO"};